import { DocumentPage } from '@/components/DocumentPage'

/**
 * Страница /refund — Refund Policy (EU, право на отказ в течение 14 дней).
 * Разметка-скелет: финальный юридический текст предоставляет заказчик.
 */
const SECTIONS: { heading: string; body: string }[] = [
  { heading: '1. Right of withdrawal (14 days)', body: 'Under EU consumer law you have the right to withdraw from a purchase within 14 days without giving a reason. [Final text to be provided.]' },
  { heading: '2. Digital content exception', body: 'For digital content, the right of withdrawal ends once you start accessing the course, provided you gave prior consent and acknowledged the loss of the withdrawal right.' },
  { heading: '3. How to request a refund', body: 'To request a refund, contact us at [email] with your order details within the withdrawal period.' },
  { heading: '4. Processing and timeframe', body: 'Approved refunds are returned using the original payment method within 14 days of your request.' },
  { heading: '5. Contact', body: 'For refund questions contact us at [email].' },
]

export const RefundPage = () => (
  <DocumentPage title="Refund Policy">
    <p><em>This is a working draft. The final legal text will be provided.</em></p>
    {SECTIONS.map(section => (
      <section key={section.heading}>
        <h2>{section.heading}</h2>
        <p>{section.body}</p>
      </section>
    ))}
  </DocumentPage>
)

export default RefundPage
